import { Analytics } from '@analytics';
import { TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { useIntl } from 'react-intl';
import * as yup from 'yup';
import CustomSection from '../CustomSection';
import { useSetupPreview } from '../SetupPreviewContext';
import messages from './messages';

const useStyles = makeStyles({
  textField: {
    width: '100%',
    fontSize: '14px',
    color: '#000',
    fontWeight: 500,

    '& .MuiFormHelperText-root': {
      backgroundColor: 'transparent'
    },

    '& .MuiInputBase-root': {
      backgroundColor: '#fff',
      color: '#000',
      fontWeight: 500
    }
  }
});

const initialValues = {
  chooserTitle: '',
  chooserText: ''
};

const landingMessageSchema = yup.object({
  chooserTitle: yup.string(),
  chooserText: yup.string()
});

// The chooser greeting lives directly on postTipPage (alongside socialLinks,
// upsell, externalLinks) so it round-trips through the same features save/read
// path and reaches the tipping page's Chooser as featureDetails.chooserTitle/Text.
const LandingMessageSection = ({ chooserTitle, chooserText, updateCompanyFeatures }) => {
  const intl = useIntl();
  const classes = useStyles();
  const { updatePreview } = useSetupPreview();

  const handleSave = values => {
    Analytics.track('Thank You Message saved', {
      page: 'setup'
    });

    updateCompanyFeatures({
      chooserTitle: values.chooserTitle,
      chooserText: values.chooserText
    });
  };

  const renderSectionBody = ({ values, errors, touched, handleChange, handleBlur }) => (
    <div className="flex flex-col gap-5 w-full">
      <TextField
        type="text"
        name="chooserTitle"
        className={classes.textField}
        label={intl.formatMessage(messages.chooserTitle)}
        variant="outlined"
        placeholder={intl.formatMessage(messages.chooserTitlePlaceholder)}
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.chooserTitle}
        error={touched?.chooserTitle && Boolean(errors?.chooserTitle)}
        helperText={touched?.chooserTitle && errors?.chooserTitle}
      />
      <TextField
        multiline
        minRows={4}
        type="text"
        name="chooserText"
        className={classes.textField}
        label={intl.formatMessage(messages.chooserText)}
        variant="outlined"
        placeholder={intl.formatMessage(messages.chooserTextPlaceholder)}
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.chooserText}
        error={touched?.chooserText && Boolean(errors?.chooserText)}
        helperText={touched?.chooserText && errors?.chooserText}
      />
    </div>
  );

  return (
    <CustomSection
      id="LandingMessage"
      title={intl.formatMessage(messages.title)}
      description={intl.formatMessage(messages.description)}
      renderBody={renderSectionBody}
      buttonTitle={intl.formatMessage(messages.save)}
      onSave={handleSave}
      onValuesChange={values =>
        updatePreview({
          features: { postTipPage: values }
        })
      }
      initialValues={{
        chooserTitle: chooserTitle || '',
        chooserText: chooserText || ''
      }}
      schema={landingMessageSchema}
    />
  );
};

export default LandingMessageSection;
